import { GridsterItemConfig } from 'angular-gridster2';

import { BaseEntityModel } from '../core/abstractions/base-entity.model';
import { DashboardComponentTypeEnum } from './enums/dashboard-component.enum';

export class DashboardCardModel extends BaseEntityModel {
    declare id: string;
    commandName: string;
    type: DashboardComponentTypeEnum;
    component?: any;
    defaultRows = 3;
    defaultColumns = 3;
    minRows = 2;
    minColumns = 2;
    dashboards: number; // Will use bitwise operations.
    allowMultipleInstances = false;

    readonly gridsterItem: GridsterItemConfig;

    private localStartX: number;
    private localStartY: number;

    get defaultStartX(): number {
        return this.localStartX;
    }
    set defaultStartX(newX: number) {
        this.gridsterItem.x = newX;
        this.localStartX = newX;
    }

    get defaultStartY(): number {
        return this.localStartY;
    }
    set defaultStartY(newY: number) {
        this.gridsterItem.y = newY;
        this.localStartY = newY;
    }

    constructor(init: Partial<DashboardCardModel>, id?: string) {
        super();

        if (!!init) {
            Object.assign(this, init);
        }

        // for new objects set the provided id
        if (!!id) {
            this.id = id;
        }

        this.gridsterItem = {
            id: `gi-card-${this.id}`,
            cols: this.defaultColumns,
            rows: this.defaultRows,
            minItemRows: this.minRows,
            minItemCols: this.minColumns,
            x: this.localStartX,
            y: this.localStartY
        };
    }
}
